<template>
  <div class="product-service-solar-term-select">
    <img :src="`/24/${label}.jpg`" class="background" />
    <div class="select">
      <div
        :class="active == item.value ? 'active' : ''"
        v-for="item in solarTermArray"
        :key="item.value"
        @click="onClick(item)"
      >{{item.label}}</div>
    </div>
    <div class="cover">
      <img :src="`/24/${label}.jpg`" />
    </div>
    <!-- <div class="split"></div> -->
  </div>
</template>

<script>
export default {
  name: "ProductServiceSolarTermSelect",
  props: ["active"],
  data() {
    return {
      label: "",
      solarTermArray: [
        {
          label: "立春",
          value: 1
        },
        {
          label: "雨水",
          value: 2
        },
        {
          label: "惊蛰",
          value: 3
        },
        {
          label: "春分",
          value: 4
        },
        {
          label: "清明",
          value: 5
        },
        {
          label: "谷雨",
          value: 6
        },
        {
          label: "立夏",
          value: 7
        },
        {
          label: "小满",
          value: 8
        },
        {
          label: "芒种",
          value: 9
        },
        {
          label: "夏至",
          value: 10
        },
        {
          label: "小暑",
          value: 11
        },
        {
          label: "大暑",
          value: 12
        },
        {
          label: "立秋",
          value: 13
        },
        {
          label: "处暑",
          value: 14
        },
        {
          label: "白露",
          value: 15
        },
        {
          label: "秋分",
          value: 16
        },
        {
          label: "寒露",
          value: 17
        },
        {
          label: "霜降",
          value: 18
        },
        {
          label: "立冬",
          value: 19
        },
        {
          label: "小雪",
          value: 20
        },
        {
          label: "大雪",
          value: 21
        },
        {
          label: "冬至",
          value: 22
        },
        {
          label: "小寒",
          value: 23
        },
        {
          label: "大寒",
          value: 24
        }
      ]
    };
  },
  created() {
    this.label = this.solarTermArray.find(e => e.value == this.active).label;
  },
  methods: {
    onClick(e) {
      this.label = e.label;

      this.$emit("change", e.value);
    }
  }
};
</script>

<style lang="less" scoped>
.product-service-solar-term-select {
  width: 1060px;
  height: 240px;
  margin: 20px 0;

  padding: 15px;

  background: #444;
  border-radius: 10px;
  opacity: 0.99;

  img.background {
    position: absolute;
    width: 1060px;
    height: 240px;

    -webkit-filter: blur(15px);
    filter: blur(15px);
  }

  .select {
    display: inline-block;
    width: 530px;
    vertical-align: top;
    // margin: 0 15px;
    div {
      display: inline-block;
      width: 75px;

      height: 50px;
      margin: 5px;
      line-height: 50px;
      text-align: center;
      background: #aaa;
      border-radius: 3px;
      opacity: 0.9;

      color: white;

      cursor: pointer;
    }

    div.active {
      color: #1b994f;

      font-weight: bold;

      background: white;
    }
  }

  .cover {
    width: 510px;
    height: 230px;
    // margin: 20px;
    padding: 5px 5px 5px 15px;
    vertical-align: top;
    display: inline-block;
    opacity: 0.99;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>

